"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanOrderType = exports.CreatedSource = void 0;
/**
 * 单据来源
 */
var CreatedSource;
(function (CreatedSource) {
    CreatedSource["App"] = "APP";
    CreatedSource["Pos"] = "POS";
    CreatedSource["WebAdmin"] = "WEB_ADMIN";
})(CreatedSource || (exports.CreatedSource = CreatedSource = {}));
/**
 * 计划单类型
 */
var PlanOrderType;
(function (PlanOrderType) {
    PlanOrderType["FromTask"] = "FROM_TASK";
    PlanOrderType["FromBoard"] = "FROM_BOARD";
    PlanOrderType["FromDistributionCenter"] = "FROM_DISTRIBUTION_CENTER";
    PlanOrderType["FromRequestOrder"] = "FROM_REQUEST_ORDER";
    PlanOrderType["Manual"] = "MANUAL";
    PlanOrderType["FromOrder"] = "FROM_ORDER";
    PlanOrderType["FromSafeStock"] = "FROM_SAFE_STOCK";
    PlanOrderType["FromPlanOrder"] = "FROM_PRODUCE_PLAN_ORDER";
})(PlanOrderType || (exports.PlanOrderType = PlanOrderType = {}));
